import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-home-page-block',
    templateUrl: './home-page-block.component.html',
    styleUrls: ['./home-page-block.component.scss'],
    standalone: false
})
export class HomePageBlockComponent implements OnInit {
  @Input() contentPage: {};
  @Input() userName: string;
  @Input() tenantName: string;
  constructor() {}

  ngOnInit() {}

  get isContentLoaded(): boolean {
    return Object.keys(this.contentPage).length > 0;
  }
}
